import { atom } from 'jotai';

export interface UpdateEDTInfoPayload {
  id: string;
  name: string;
  subtitle?: string;
}

export const updateEDTInfoPayloadAtom = atom<UpdateEDTInfoPayload | undefined>(
  undefined,
);
